<style>
.disabledTab {
	pointer-events: none;
}
</style>
<template>
	<div class="loan-eligibility-calculator">

		<LoanEcHeaderInfo />

		<LoanType :is-view-only.sync="isViewOnly" :loan_type_id="formData.loan_type_id" @change="setLoanType" />

		<IncomeDetails :is-view-only.sync="isViewOnly" :currentLoanData="formData" @change="setEligibleDetail" />

		<CommitmentDetails />

		<CCRISitems :is-view-only.sync="isViewOnly" @change="setCcris" />

		<NonCCRISitems :is-view-only.sync="isViewOnly" @change="setNonCcris" />

		<OtherPayment :is-view-only.sync="isViewOnly" @change="setOtherPayment" />

		<ProposedRepayment :is-view-only.sync="isViewOnly" @change="setRePayment" />

		<CreditLoanApplication :is-view-only.sync="isViewOnly" @change="setCreditLoan" />

		<SummaryItems :is-view-only.sync="isViewOnly" @change="setSummary"/>

		<div class="w-100 text-center" v-if="!is_loading">
			<el-button type="danger" @click="reject(true)" icon="el-icon-close" :loading="is_loading_btn"
				v-if="activeLoanEC && (activeLoanEC.status == 'Pending Submission' || activeLoanEC.status == null) && !isViewOnly">
				Reject
			</el-button>
			<el-button type="primary" @click="submit()" icon="el-icon-check" :loading="is_loading_btn"
				v-if="activeLoanEC && (activeLoanEC.status == 'Pending Submission' || activeLoanEC.status == null) && !isViewOnly">
				Submit to Credit Manager
			</el-button>
			<el-button type="primary" @click="appeal()" icon="el-icon-check" :loading="is_loading_btn"
				v-if="activeLoanEC && (activeLoanEC.status == 'Rejected') && !isViewOnly">
				Appeal to Credit Manager
			</el-button>
			<el-button type="danger" @click="reject()" icon="el-icon-close" :loading="is_loading_btn"
				v-if="(activeLoanEC && activeLoanEC.status == 'Pending Approval') && !isViewOnly">
				Reject
			</el-button>
			<el-button type="primary" @click="approve()" icon="el-icon-check" :loading="is_loading_btn"
				v-if="(activeLoanEC && activeLoanEC.status == 'Pending Approval') && !isViewOnly">
				Approve as Customer
			</el-button>
		</div>
	</div>
</template>

<script>
import { gEventBus } from '@/assets/js/EventBus/gEventBus.js'
import { cloneDeep } from 'lodash'
import { Button } from 'element-ui';
import { calculateRule78, calculateFactoryLoan, calculateShortTermLoan, calculateLoanEligibility, calculateFlexiLoan, calculateAngkasaLoan } from '@/assets/js/calculator';
import LoanEcHeaderInfo from '@/views/CustomerProfile/CenterComponents/LoanEligible/Cards/LoanEcHeaderInfo'
import LoanType from '@/views/CustomerProfile/CenterComponents/LoanEligible/Cards/LoanType'
import IncomeDetails from '@/views/CustomerProfile/CenterComponents/LoanEligible/Cards/IncomeDetails'
import CommitmentDetails from '@/views/CustomerProfile/CenterComponents/LoanEligible/Cards/CommitmentDetails'
import CCRISitems from '@/views/CustomerProfile/CenterComponents/LoanEligible/Cards/CCRISitems'
import NonCCRISitems from '@/views/CustomerProfile/CenterComponents/LoanEligible/Cards/NonCCRISitems'
import OtherPayment from '@/views/CustomerProfile/CenterComponents/LoanEligible/Cards/OtherPayment'
import ProposedRepayment from '@/views/CustomerProfile/CenterComponents/LoanEligible/Cards/ProposedRepayment'
import SummaryItems from '@/views/CustomerProfile/CenterComponents/LoanEligible/Cards/SummaryItems'
import CreditLoanApplication from '@/views/CustomerProfile/CenterComponents/LoanEligible/Cards/CreditLoanApplication'
import { mapState, mapActions } from 'pinia';
import { useCustomerStore } from '@/stores/customerStore';
import { useCommonStore } from '@/stores/commonStore';
import { useAuthStore } from '@/stores/authStore';
import { useProposalStore } from '@/stores/proposalStore';
import { useNotificationStore } from '@/stores/notificationStore';
import { useMessagingStore } from '@/stores/messagingStore';

export default {
	props: ['is-view-only','refresh'],
	components: {
		LoanEcHeaderInfo,
		LoanType,
		IncomeDetails,
		CommitmentDetails,
		CCRISitems,
		NonCCRISitems,
		OtherPayment,
		ProposedRepayment,
		SummaryItems,
		CreditLoanApplication,
		[Button.name]: Button,
	},
	data() {
		return {
			oldFormData: {
				loan_type_id: ''
			},
			formData: {
				loan_type_id: ''
			}
		}
	},
	created() {
		this.initComponent();
		gEventBus.$on('caclculate-loan-eligible', this.calcLoanEligible)
		gEventBus.$on('caclculate-loan-flexi', this.calcLoanFlexi)
	},
	beforeDestroy() {
		gEventBus.$off('caclculate-loan-eligible', this.calcLoanEligible)
		gEventBus.$off('caclculate-loan-flexi', this.calcLoanFlexi)
		this.clearComponent()
	},
	beforeUnmount(){
		this.clearComponent()
	},
	computed: {
		...mapState(useCustomerStore, ['activeCustomer', 'activeCustomerInv', 'activeLoanEC', 'activeFormLoanEc']),
		...mapState(useAuthStore, ['getLoginInfo']),
		...mapState(useCommonStore, ['loanTypes']),
		is_tab_init() {
			return _gHlp.isLoading('init_tab_loan_eligible')
		},
		is_loading_btn() {
			return _gHlp.isLoading('proceed_approval')
		},
		is_loading(){
			return _gHlp.isLoading('fetch_loan_type') || _gHlp.isLoading('calc_loan_eligible') || _gHlp.isLoading('calc_loan_calculator') || _gHlp.isLoading('fetch_ccris_items') || _gHlp.isLoading('fetch_non_ccris_items') || _gHlp.isLoading('fetch_oth_payment_items') || _gHlp.isLoading('fetch_loan_ec')
		}
	},
	watch: {
		activeLoanEC: {
			handler(newVal) {
				if (!_gHlp.isEmpty(newVal)) {
					this.populateExistingData();
				}
			},
			immediate: true
		},
		activeFormLoanEc: {
			handler(newVal) {
				if (!_gHlp.isEmpty(newVal)) {
					this.oldFormData = cloneDeep(this.formData)
					this.formData = { ...this.formData, ...newVal }
				}
			},
			immediate: true
		},
		is_tab_init: {
			handler(newVal) {
				if (newVal == true) {
					this.initComponent();
				}
			},
			immediate: true
		},
		refresh: {
			handler(newVal) {
				if (newVal == true) {
					this.initComponent();
				}
			},
			immediate: true
		}
	},
	methods: {
		...mapActions(useCustomerStore, [
			'getLoanEC',
			'getCCRISCommitmentList',
			'getNonCCRISCommitmentList',
			'getOtherPaymentList',
			'getProposedRepaymentList',
			'createLoanEC',
			'updateLoanEC',
			'submitLoanEC',
			'rejectLoanEC',
			'appealLoanEC',
			'approveLoanEC',
			'setFormLoanEc'
		]),
		...mapActions(useProposalStore, ['syncToSas']),
		...mapActions(useNotificationStore, ['createBellNotif']),
		...mapActions(useMessagingStore, ['createSendEmail']),
		clearComponent(){
			this.oldFormData = { loan_type_id: ''}
			this.formData = { loan_type_id: '' }
		},
		initComponent() {
			_gHlp.setLoading('fetch_ccris_items')
			_gHlp.setLoading('fetch_non_ccris_items')
			_gHlp.setLoading('fetch_oth_payment_items')
			_gHlp.setLoading('fetch_repayment_items')
			if (_gHlp.isEmpty(this.activeLoanEC)) {
				let lec_id = this.$route.query.lec_id;
				if(_gHlp.isEmpty(lec_id)){
					this.$router.push('/customers-list/pending-acceptance')
				}else{
					this.getLoanEC(lec_id).then(resp => {
						this.fetchAllRelations();
					}).catch(err => {
					});
				}
			} else {
				this.fetchAllRelations()
			}
		},
		fetchAllRelations(){
			this.populateExistingData()
			this.getCCRISCommitmentList().then(resp => { _gHlp.removeLoading('fetch_ccris_items') }).catch(err => { _gHlp.removeLoading('fetch_ccris_items') });
			this.getNonCCRISCommitmentList().then(resp => { _gHlp.removeLoading('fetch_non_ccris_items') }).catch(err => { _gHlp.removeLoading('fetch_non_ccris_items') });
			this.getOtherPaymentList().then(resp => { _gHlp.removeLoading('fetch_oth_payment_items') }).catch(err => { _gHlp.removeLoading('fetch_oth_payment_items') });
			this.getProposedRepaymentList().then(resp => { _gHlp.removeLoading('fetch_repayment_items') }).catch(err => { _gHlp.removeLoading('fetch_repayment_items') });
		},
		setLoanType(loan_type_id) {
			if (!_gHlp.isEmpty(this.loanTypes) && !_gHlp.isEmpty(loan_type_id)) {
				let selectedLoanType = this.loanTypes.find(itm => itm.id == loan_type_id);
				this.formData.loan_type_id = loan_type_id;
				if (!_gHlp.isEmpty(selectedLoanType)) {
					this.formData.selectedLoanType = selectedLoanType;
					this.calcLoanEligible();
				}
			}
		},
		setEligibleDetail(loanEligible) {
			if (!_gHlp.isEmpty(loanEligible)) {
				let with_save = loanEligible.is_save;
				delete loanEligible['is_save'];

				this.formData = { ...this.formData, ...loanEligible };
				this.calcLoanEligible();
				this.calcLoanCalculator(with_save);
			}
		},
		setCreditLoan(with_save = false) {
			this.formData.loan_amount = _gHlp.getValue(this.activeFormLoanEc, 'loan_amount');
			this.formData.interest_rate = _gHlp.getValue(this.activeFormLoanEc, 'interest_rate');
			this.formData.moratorium_eligible = _gHlp.getValue(this.activeFormLoanEc, 'moratorium_eligible');
			this.formData.moratorium_eligible_rate = _gHlp.getValue(this.activeFormLoanEc, 'moratorium_eligible_rate');
			this.formData.moratorium_tenure = _gHlp.getValue(this.activeFormLoanEc, 'moratorium_tenure');
			this.formData.flexi_loan_eligible = _gHlp.getValue(this.activeFormLoanEc, 'flexi_loan_eligible');
			this.formData.flexi_loan_amount = _gHlp.getValue(this.activeFormLoanEc, 'flexi_loan_amount');
			this.formData.flexi_interest_rate = parseFloat(_gHlp.getValue(this.activeFormLoanEc, 'flexi_interest_rate'));

			//ENABLED MORATORIUM
			if (!_gHlp.isEmpty(this.oldFormData.moratorium_eligible) && (this.oldFormData.moratorium_eligible != this.formData.moratorium_eligible) && (this.formData.moratorium_eligible == 1)) {
				if (!_gHlp.isEmpty(this.formData.selectedLoanType)) {
					if (this.formData.moratorium_tenure <= 0) this.formData.moratorium_tenure = _gHlp.getValue(this.formData.selectedLoanType, 'moratorium_tenure', 0)
					if (this.formData.moratorium_eligible_rate <= 0) this.formData.moratorium_eligible_rate = _gHlp.getValue(this.formData.selectedLoanType, 'moratorium_installment_percentage', 0)
					if (this.formData.moratorium_start_period <= 0) this.formData.moratorium_start_period = 1
				}
			}

			//DISABLED FLEXI
			if (!_gHlp.isEmpty(this.oldFormData.flexi_loan_eligible) && (this.oldFormData.flexi_loan_eligible != this.formData.flexi_loan_eligible) && (this.formData.flexi_loan_eligible == 0)) {
				this.formData.flexi_loan_amount = 0;
				this.formData.flexi_interest_rate = 0;
			}

			this.calcLoanEligible();
			this.calcLoanFlexi();
			this.calcLoanCalculator(with_save);
		},
		setCcris(with_save = false) {
			this.formData.ccrisItemsSettleList = _gHlp.getValue(this.activeFormLoanEc, 'ccrisItemsSettleList');
			this.formData.ccris_commitment = _gHlp.getValue(this.activeFormLoanEc, 'ccris_commitment');
			this.formData.ccris_settlement = _gHlp.getValue(this.activeFormLoanEc, 'ccris_settlement');
			this.formData.final_installment = _gHlp.getValue(this.activeFormLoanEc, 'final_installment');
			this.calcLoanEligible();
			this.calcLoanCalculator(with_save);
		},
		setNonCcris(with_save = false) {
			this.formData.nonCcrisItemsSettleList = _gHlp.getValue(this.activeFormLoanEc, 'nonCcrisItemsSettleList');
			this.formData.non_ccris_outstanding = _gHlp.getValue(this.activeFormLoanEc, 'non_ccris_outstanding');
			this.formData.non_ccris_settlement = _gHlp.getValue(this.activeFormLoanEc, 'non_ccris_settlement');
			this.calcLoanEligible();
			this.calcLoanCalculator(with_save);
		},
		setOtherPayment(with_save = false) {
			this.formData.othPaymentItemsList = _gHlp.getValue(this.activeFormLoanEc, 'othPaymentItemsList');
			this.formData.other_payment_outstanding = _gHlp.getValue(this.activeFormLoanEc, 'other_payment_outstanding');
			this.formData.other_payment_settlement = _gHlp.getValue(this.activeFormLoanEc, 'other_payment_settlement');
			this.calcLoanEligible();
			this.calcLoanCalculator(with_save);
		},
		setRePayment(with_save = false) {
			this.formData.repaymentItemsList = _gHlp.getValue(this.activeFormLoanEc, 'repaymentItemsList');
			this.formData.repayment_loan_amount = _gHlp.getValue(this.activeFormLoanEc, 'repayment_loan_amount');
			this.calcLoanEligible();
			if (this.formData.flexi_loan_eligible == 1) {
				this.calcLoanFlexi();
			}
			this.calcLoanCalculator(with_save);
		},

		// setLoanEligible(loanEligible) {
		// 	this.loanEligible = loanEligible;
		// 	this.calculator.loan_amount = loanEligible.eligible_amount;
		// 	this.calculator.loan_tenure = loanEligible.period_number;
		// },
		// setMoratoriumAppoval(moratoriumApproval) {
		// 	this.moratoriumApproval = moratoriumApproval;
		// },
		// setMoratoriumEligible(moratoriumEligible) {
		// 	this.calculator.moratorium_eligible = moratoriumEligible;
		// },
		// setApprovalStatus(approvalStatus) {
		// 	this.approvalStatus = approvalStatus;
		// },
		setMoratorium(with_save = false) {
			// this.calcLoanEligible({with_save:with_save, with_calculator:true})
		},
		setFlexi(with_save = false) {

			// this.calcLoanFlexi(with_save);
		},
		setSummary(with_save = false) {
			this.formData.stamp_duty = parseFloat(_gHlp.getValue(this.activeFormLoanEc, 'stamp_duty', 0))
			this.formData.vet_fac_amt = parseFloat(_gHlp.getValue(this.activeFormLoanEc, 'vet_fac_amt', 0))
			this.formData.stakeholder_sum = parseFloat(_gHlp.getValue(this.activeFormLoanEc, 'stakeholder_sum', 0))
			this.formData.legal_fees = parseFloat(_gHlp.getValue(this.activeFormLoanEc, 'legal_fees', 0))
			this.calcLoanSummary();
			if (with_save) {
				this.updateLoan()
			}
		},
		// setCalculatorAmount(calculator) {
		// 	this.calculator.loan_amount = calculator.loan_amount;
		// 	this.calculator.interest_rate = calculator.interest_rate;
		// },
		// setFlexiAmount(flexiAmount) {
		// 	this.calculator.flexi_loan_amount = flexiAmount.flexi_loan_amount;
		// 	this.calculator.flexi_interest_rate = flexiAmount.flexi_interest_rate;
		// },
		calculateLoan(data, loanType) {
			// console.log(` Loan Type: `, loanType);
			// Check loan type and call corresponding function
			if (loanType.code === 'FL') {
				// Factory loan
				return calculateFactoryLoan(data, loanType);
			} else if (loanType.loan_tenure_period === 'Years' && loanType.interest_rate_period === 'Years') {
				// Rule 78 loan
				return calculateRule78(data, loanType);
			} else if ((loanType.loan_tenure_period === 'Months' && loanType.interest_rate_period === 'One Time') || loanType.code === 'FEL') {
				// Short term loan
				return calculateShortTermLoan(data, loanType);
			} else if (loanType.code === 'AK') {
  				return calculateAngkasaLoan(data, loanType);
			} else {
				// Invalid loan type
				return null;
			}
		},
		calcLoanCalculator(with_save = false) {
			_gHlp.setLoading('calc_loan_calculator')
			if (!_gHlp.isEmpty(this.formData.selectedLoanType)) {
				let data = {
					loan_amount: this.formData.loan_amount || 0,
					loan_tenure: this.formData.loan_tenure || 1,
					interest_rate: this.formData.interest_rate
				};

				let adv_multply = 1;
				if (data.loan_tenure <= 2) {
					adv_multply = 1;
				} else if (data.loan_tenure <= 4) {
					adv_multply = 2;
				} else if (data.loan_tenure <= 6) {
					adv_multply = 3;
				} else {
					adv_multply = 4;
				}

				if (this.formData.moratorium_eligible == 1) {
					data['moratorium_tenure'] = this.formData.moratorium_tenure;
					data['moratorium_eligible_rate'] = this.formData.moratorium_eligible_rate;
					data['moratorium_start_period'] = this.formData.moratorium_start_period;
				}
				const result = this.calculateLoan(data, this.formData.selectedLoanType);
				if (!_gHlp.isEmpty(result)) {
					this.formData.loanTableList = result.loan_table;
					this.formData.loan_amount = result.loan_amount;
					this.formData.interest_rate = result.interest_rate;
					this.formData.total_interest = result.total_interest;
					this.formData.installment_amount = result.installment;
					this.formData.total_amount_paid = result.total_amount_paid;
					// this.formData.adv_payment_amount = this.formData.installment_amount * adv_multply;
					this.formData.moratorium_tenure = _gHlp.getValue(result, 'moratorium_tenure', 0);
					this.formData.moratorium_installment = _gHlp.getValue(result, 'moratorium_installment', 0);
					this.formData.moratorium_start_period = _gHlp.getValue(result, 'moratorium_start_period', 1);
					this.formData.stamp_duty = result.stamp_duty;

					this.calcLoanSummary()
					this.setFormLoanEc(this.formData)

					if (with_save) {
						this.updateLoan()
					}
				}
			}
			_gHlp.removeLoading('calc_loan_calculator')
		},
		calcLoanEligible() {
			_gHlp.setLoading('calc_loan_eligible')
			if (!_gHlp.isEmpty(this.formData.selectedLoanType)) {
				const params = {
					net_income: parseFloat(_gHlp.getValue(this.formData,'net_income',0)),
					interest_rate: parseFloat(_gHlp.getValue(this.formData,'interest_rate',0)),
					net_dispose_income: parseFloat(_gHlp.getValue(this.formData,'net_dispose_income',0)),
					ccris_commitment: parseFloat(_gHlp.getValue(this.formData,'ccris_commitment',0)),
					final_installment: parseFloat(_gHlp.getValue(this.formData,'final_installment',0)),
					ccris_settlement: parseFloat(_gHlp.getValue(this.formData,'ccris_settlement',0)),
					non_ccris_settlement: parseFloat(_gHlp.getValue(this.formData,'non_ccris_settlement',0)),
					other_payment_settlement: parseFloat(_gHlp.getValue(this.formData,'other_payment_settlement',0)),
					moratorium_eligible: (_gHlp.getValue(this.formData, 'moratorium_eligible', 0) == 1),
					moratorium_eligible_rate: parseFloat(_gHlp.getValue(this.formData, 'moratorium_eligible_rate', 50)),

					stamp_duty: parseFloat(_gHlp.getValue(this.formData, 'stamp_duty', 0)),
					vet_fac_amt: parseFloat(_gHlp.getValue(this.formData, 'vet_fac_amt', 0)),
					stakeholder_sum: parseFloat(_gHlp.getValue(this.formData, 'stakeholder_sum', 0)),
					legal_fees: parseFloat(_gHlp.getValue(this.formData, 'legal_fees', 0)),
				};
				const result = calculateLoanEligibility(params, this.formData.selectedLoanType)
				if (!_gHlp.isEmpty(result)) {
					// let loanEligibleList = result.loan_eligible;
					// if (!_gHlp.isEmpty(loanEligibleList)) {
					// 	loanEligibleList.map(item => {
					// 		if (item.period === this.activeLoanEC.loan_eligible_period && item.status !== 'FAIL') {
					// 			item.selected = true;
					// 		}
					// 		return item
					// 	});
					// }
					this.formData.loanEligibleList = result.loan_eligible;
					this.formData.installment_eligible = result.installment_eligible;
					this.formData.installment_available = result.installment_available;
					this.setFormLoanEc(this.formData)
				}
			}
			_gHlp.removeLoading('calc_loan_eligible')
		},
		calcLoanFlexi(with_save = false) {
			let flexiLoanType = this.loanTypes.find(item => item.code === 'FEL');
			let repayment_loan_amount = _gHlp.getValue(this.formData, 'repayment_loan_amount', 0);
			let loan_amount = _gHlp.getValue(this.formData, 'loan_amount', 0);

			if (!_gHlp.isEmpty(flexiLoanType)) {
				this.formData.flexi_eligible_limit = repayment_loan_amount - loan_amount;
				if (this.formData.flexi_eligible_limit < 0) this.formData.flexi_eligible_limit = 0;
				if (this.formData.flexi_loan_amount <= 0) {
					if (this.formData.flexi_eligible_limit >= 0) {
						this.formData.flexi_loan_amount = this.formData.flexi_eligible_limit;
					}
				}

				if (this.formData.flexi_loan_tenure == 0) {
					this.formData.flexi_loan_tenure = flexiLoanType.loan_tenure;
				}
				if (this.formData.flexi_interest_rate == 0) {
					this.formData.flexi_interest_rate = flexiLoanType.interest_rate;
				}

				if (
					this.formData.flexi_loan_tenure > 0 &&
					this.formData.flexi_interest_rate > 0 &&
					this.formData.flexi_loan_amount > 0
				) {
					const params = {
						loan_amount: this.formData.flexi_loan_amount,
						loan_tenure: this.formData.flexi_loan_tenure,
						interest_rate: this.formData.flexi_interest_rate,
					};
					const result = calculateFlexiLoan(params, flexiLoanType)
					this.formData.flexiLoanTableList = result.loan_table
					this.formData.flexi_interest_rate = result.interest_rate
					if (this.formData.flexi_loan_amount > this.formData.flexi_eligible_limit) {
						this.formData.flexi_loan_amount = this.formData.flexi_eligible_limit;
					} else {
						this.formData.flexi_loan_amount = result.loan_amount
					}
					this.formData.flexi_loan_tenure = result.loan_tenure
					this.setFormLoanEc(this.formData)

					if (with_save) {
						this.updateLoan()
					}
				}
			}
		},
		calcLoanSummary(){
			this.formData.debt_consolidation_amount = 0;
      this.formData.bal_disbursement_amount = 0;
			if (!_gHlp.isEmpty(this.formData.selectedLoanType)) {
				if (!_gHlp.isEmpty(this.formData.ccrisItemsSettleList) && this.formData.ccrisItemsSettleList.length > 0) {
					this.formData.ccrisItemsSettleList.forEach(el => {
						this.formData.debt_consolidation_amount += el.invinity_solution;
					});
				}
				if (!_gHlp.isEmpty(this.formData.nonCcrisItemsSettleList) && this.formData.nonCcrisItemsSettleList.length > 0) {
					this.formData.nonCcrisItemsSettleList.forEach(el => {
						this.formData.debt_consolidation_amount += el.invinity_solution;
					});
				}
				if (!_gHlp.isEmpty(this.formData.othPaymentItemsList) && this.formData.othPaymentItemsList.length > 0) {
					this.formData.othPaymentItemsList.forEach(el => {
						this.formData.debt_consolidation_amount += el.settlement;
					});
				}

				this.formData.bal_disbursement_amount = parseFloat(this.formData.loan_amount) - parseFloat(this.formData.debt_consolidation_amount);
				this.setFormLoanEc(this.formData)
			}
		},
		populateExistingData() {
			this.formData.loan_type_id = _gHlp.getValue(this.activeLoanEC, 'loan_type_id', this.formData.loan_type_id);
			this.formData.gross_income = _gHlp.getValue(this.activeLoanEC, 'gross_income', this.formData.gross_income);
			this.formData.net_income = _gHlp.getValue(this.activeCustomer, 'incomes.main.net_income', this.formData.net_income);
			this.formData.balance_commitment = _gHlp.getValue(this.activeLoanEC, 'balance_commitment', this.formData.balance_commitment);
			this.formData.dsr = _gHlp.getValue(this.activeLoanEC, 'dsr', this.formData.dsr);
			this.formData.net_dispose_income = _gHlp.getValue(this.activeLoanEC, 'net_dispose_income', 1000);
			this.formData.installment_eligible = _gHlp.getValue(this.activeLoanEC, 'installment_eligible', 0);
			this.formData.total_amount_paid = _gHlp.getValue(this.activeLoanEC, 'total_amount_paid', 0);
			this.formData.total_interest = _gHlp.getValue(this.activeLoanEC, 'total_interest', 0);
			this.formData.installment_amount = _gHlp.getValue(this.activeLoanEC, 'installment_amount', 0);
			this.formData.installment_available = _gHlp.getValue(this.activeLoanEC, 'installment_available', 0);
			// this.formData.adv_payment_amount = _gHlp.getValue(this.activeLoanEC, 'adv_payment_amount', 0);
			this.formData.loan_amount = _gHlp.getValue(this.activeLoanEC, 'loan_amount', 0);
			this.formData.loan_tenure = _gHlp.getValue(this.activeLoanEC, 'loan_tenure', 1);
			this.formData.loan_tenure_period = _gHlp.getValue(this.activeLoanEC, 'loan_tenure_period', 'Years');
			this.formData.loan_tenure_year = _gHlp.getValue(this.activeLoanEC, 'loan_tenure_year', 0);
			this.formData.loan_eligible_period = _gHlp.getValue(this.activeLoanEC, 'loan_eligible_period', '');
			this.formData.interest_rate = _gHlp.getValue(this.activeLoanEC, 'interest_rate');
			this.formData.moratorium_eligible = _gHlp.getValue(this.activeLoanEC, 'moratorium_eligible', 0);
			this.formData.moratorium_tenure = _gHlp.getValue(this.activeLoanEC, 'moratorium_tenure', 0);
			this.formData.moratorium_eligible_rate = _gHlp.getValue(this.activeLoanEC, 'moratorium_eligible_rate', 0);
			this.formData.moratorium_installment = _gHlp.getValue(this.activeLoanEC, 'moratorium_installment', 0);
			this.formData.moratorium_approval_status = _gHlp.getValue(this.activeLoanEC, 'moratorium_approval_status', null);
			this.formData.moratorium_start_period = _gHlp.getValue(this.activeLoanEC, 'moratorium_start_period', null);
			this.formData.flexi_loan_eligible = _gHlp.getValue(this.activeLoanEC, 'flexi_loan_eligible', 0);
			this.formData.flexi_loan_amount = _gHlp.getValue(this.activeLoanEC, 'flexi_loan_amount', this.formData.flexi_loan_amount || 0);
			this.formData.flexi_loan_status = _gHlp.getValue(this.activeLoanEC, 'flexi_loan_status', this.formData.flexi_loan_status || 0);
			this.formData.flexi_interest_rate = _gHlp.getValue(this.activeLoanEC, 'flexi_interest_rate', this.formData.flexi_interest_rate || 0);
			this.formData.flexi_loan_tenure = _gHlp.getValue(this.activeLoanEC, 'flexi_loan_tenure', this.formData.flexi_loan_tenure || 0);
			this.formData.stamp_duty = _gHlp.getValue(this.activeLoanEC, 'stamp_duty', this.formData.stamp_duty || 0);
			this.formData.stamping_fee_prc = _gHlp.getValue(this.activeLoanEC, 'stamping_fee_prc', this.formData.stamping_fee_prc || 0);
			this.formData.stakeholder_sum = _gHlp.getValue(this.activeLoanEC, 'stakeholder_sum', this.formData.stakeholder_sum || 0);
			this.formData.stakeholder_mth = _gHlp.getValue(this.activeLoanEC, 'stakeholder_mth', this.formData.stakeholder_mth || 0);
			this.formData.vet_fac_prc = _gHlp.getValue(this.activeLoanEC, 'vet_fac_prc', this.formData.vet_fac_prc || 0);
			this.formData.vet_fac_sst = _gHlp.getValue(this.activeLoanEC, 'vet_fac_sst', this.formData.vet_fac_sst || 8);
			this.formData.vet_fac_amt = _gHlp.getValue(this.activeLoanEC, 'vet_fac_amt', this.formData.vet_fac_amt || 0);
			this.formData.legal_base_amt = _gHlp.getValue(this.activeLoanEC, 'legal_base_amt', this.formData.legal_base_amt || 0);
			this.formData.legal_sst_prc = _gHlp.getValue(this.activeLoanEC, 'legal_sst_prc', this.formData.legal_sst_prc || 8);
			this.formData.legal_fees = _gHlp.getValue(this.activeLoanEC, 'legal_fees', this.formData.legal_fees || 0);
			this.formData.approval_status_flexi = _gHlp.getValue(this.activeLoanEC, 'flexi_loan_status', 0);
			this.formData.approval_status_credit = _gHlp.getValue(this.activeLoanEC, 'status', 0);
			this.formData.ccris_commitment = _gHlp.getValue(this.activeLoanEC, 'ccris_commitment', 0);
			this.formData.ccris_settlement = _gHlp.getValue(this.activeLoanEC, 'ccris_settlement', 0);
			this.formData.final_installment = _gHlp.getValue(this.activeLoanEC, 'final_installment', 0);
			this.formData.non_ccris_settlement = _gHlp.getValue(this.activeLoanEC, 'non_ccris_settlement', 0);
			this.formData.other_payment_settlemen = _gHlp.getValue(this.activeLoanEC, 'other_payment_settlemen', 0);
			this.setFormLoanEc(this.formData)
		},
		setUpdateData(){
			return {
				loan_type_id: this.formData.loan_type_id,
				gross_income: this.formData.gross_income,
				net_income: this.formData.net_income,
				balance_commitment: this.formData.balance_commitment,
				dsr: this.formData.dsr,
				net_dispose_income: this.formData.net_dispose_income,
				installment_eligible: this.formData.installment_eligible,
				total_amount_paid: this.formData.total_amount_paid,
				total_interest: this.formData.total_interest,
				installment_amount: this.formData.installment_amount,
				installment_available: this.formData.installment_available,
				// adv_payment_amount: this.formData.adv_payment_amount,
				loan_amount: this.formData.loan_amount,
				loan_tenure: this.formData.loan_tenure,
				loan_tenure_period: this.formData.loan_tenure_period,
				loan_tenure_year: this.formData.loan_tenure_year,
				loan_eligible_period: this.formData.loan_eligible_period,
				interest_rate: this.formData.interest_rate,
				moratorium_eligible: this.formData.moratorium_eligible,
				moratorium_tenure: this.formData.moratorium_tenure,
				moratorium_eligible_rate: this.formData.moratorium_eligible_rate,
				moratorium_installment: this.formData.moratorium_installment,
				moratorium_approval_status: this.formData.moratorium_approval_status,
				moratorium_start_period: this.formData.moratorium_start_period,
				flexi_loan_eligible: this.formData.flexi_loan_eligible,
				flexi_interest_rate: this.formData.flexi_interest_rate,
				flexi_loan_amount: this.formData.flexi_loan_amount,
				flexi_loan_status: this.formData.flexi_loan_status,
				flexi_loan_tenure: this.formData.flexi_loan_tenure,
				stamp_duty: this.formData.stamp_duty,
				flexi_interest_rate: this.formData.flexi_interest_rate,
				flexi_eligible_limit: this.formData.flexi_eligible_limit,
				ccris_commitment: this.formData.ccris_commitment,
				ccris_settlement: this.formData.ccris_settlement,
				final_installment: this.formData.final_installment,
				other_payment_settlement: this.formData.non_ccris_settlement,
				other_payment_settlement: this.formData.other_payment_settlement,
				bal_disbursement_amount: this.formData.bal_disbursement_amount,
				stamp_duty: this.formData.stamp_duty,
				stakeholder_sum: this.formData.stakeholder_sum,
				stakeholder_mth: this.formData.stakeholder_mth,
				vet_fac_amt: this.formData.vet_fac_amt,
				legal_fees: this.formData.legal_fees,
				stamping_fee_prc: this.formData.stamping_fee_prc,
				vet_fac_prc: this.formData.vet_fac_prc,
				vet_fac_sst: this.formData.vet_fac_sst,
				legal_base_amt: this.formData.legal_base_amt,
				legal_sst_prc: this.formData.legal_sst_prc,
			}
		},
		updateLoan() {
			_gHlp.setLoading('fetch_loan_ec')

			const params = this.setUpdateData()

			this.updateLoanEC(params).then(resp => {
				if (!_gHlp.isEmpty(this.activeLoanEC.psal_id)) {
					this.syncToSas(this.activeLoanEC.psal_id)
				}
				_gHlp.removeLoading('fetch_loan_ec')
			}).catch(err => {
				_gHlp.removeLoading('fetch_loan_ec')
			})
		},
		submit() {
			_gHlp.setLoading('fetch_loan_ec')
			_gHlp.setLoading('proceed_approval')
			this.submitLoanEC(this.activeLoanEC.id).then(resp => {
				this.createBellNotif('LMS_LOAN_EC_SUBMIT_APPROVAL',{id:this.activeLoanEC.id, customer_id:this.activeLoanEC.customer_id, psal_id:this.activeLoanEC.psal_id, customer_name:this.activeCustomer.name })
				this.createSendEmail('LMS_LOAN_EC_SUBMIT_APPROVAL',{id:this.activeLoanEC.id, customer_id:this.activeLoanEC.customer_id, psal_id:this.activeLoanEC.psal_id, customer_name:this.activeCustomer.name })
				_gHlp.removeLoading('fetch_loan_ec')
				_gHlp.removeLoading('proceed_approval')
				this.getLoanEC();
			}).catch(err => {
				_gHlp.removeLoading('fetch_loan_ec')
				_gHlp.removeLoading('proceed_approval')
			});
		},
		reject(is_cancel = false) {
			_gHlp.setLoading('fetch_loan_ec')
			_gHlp.setLoading('proceed_approval')
			this.rejectLoanEC(this.activeLoanEC.id).then((resp) => {
				if(is_cancel){
					this.createBellNotif('LMS_LOAN_EC_CANCEL',{id:this.activeLoanEC.id, customer_id:this.activeLoanEC.customer_id, psal_id:this.activeLoanEC.psal_id, customer_name:this.activeCustomer.name })
					this.createSendEmail('LMS_LOAN_EC_CANCEL',{id:this.activeLoanEC.id, customer_id:this.activeLoanEC.customer_id, psal_id:this.activeLoanEC.psal_id, customer_name:this.activeCustomer.name })
				}else{
					this.createBellNotif('LMS_LOAN_EC_REJECT',{id:this.activeLoanEC.id, customer_id:this.activeLoanEC.customer_id, psal_id:this.activeLoanEC.psal_id, customer_name:this.activeCustomer.name })
					this.createSendEmail('LMS_LOAN_EC_REJECT',{id:this.activeLoanEC.id, customer_id:this.activeLoanEC.customer_id, psal_id:this.activeLoanEC.psal_id, customer_name:this.activeCustomer.name })
				}
				_gHlp.removeLoading('fetch_loan_ec')
				_gHlp.removeLoading('proceed_approval')
				this.getLoanEC();
			}).catch(err => {
				_gHlp.removeLoading('fetch_loan_ec')
				_gHlp.removeLoading('proceed_approval')
			});
		},
		appeal() {
			_gHlp.setLoading('fetch_loan_ec')
			_gHlp.setLoading('proceed_approval')
			this.appealLoanEC(this.activeLoanEC.id).then((resp) => {
				this.createBellNotif('LMS_LOAN_EC_SUBMIT_APPROVAL',{id:this.activeLoanEC.id, customer_id:this.activeLoanEC.customer_id, psal_id:this.activeLoanEC.psal_id, customer_name:this.activeCustomer.name })
				this.createSendEmail('LMS_LOAN_EC_SUBMIT_APPROVAL',{id:this.activeLoanEC.id, customer_id:this.activeLoanEC.customer_id, psal_id:this.activeLoanEC.psal_id, customer_name:this.activeCustomer.name })
				_gHlp.removeLoading('fetch_loan_ec')
				_gHlp.removeLoading('proceed_approval')
				this.getLoanEC();
			}).catch(err => {
				_gHlp.removeLoading('fetch_loan_ec')
				_gHlp.removeLoading('proceed_approval')
			});
		},
		approve() {
			_gHlp.setLoading('fetch_loan_ec')
			_gHlp.setLoading('proceed_approval')
			let params = this.setUpdateData()
			params['repayment_breakdown'] = this.formData.loanTableList
			params['repayment_flexi_breakdown'] = this.formData.flexiLoanTableList
			this.approveLoanEC(this.activeLoanEC.id, params).then((resp) => {
				this.createBellNotif('LMS_LOAN_EC_APPROVED',{id:this.activeLoanEC.id, customer_id:this.activeLoanEC.customer_id, psal_id:this.activeLoanEC.psal_id, customer_name:this.activeCustomer.name })
				this.createSendEmail('LMS_LOAN_EC_APPROVED',{id:this.activeLoanEC.id, customer_id:this.activeLoanEC.customer_id, psal_id:this.activeLoanEC.psal_id, customer_name:this.activeCustomer.name })
				_gHlp.removeLoading('fetch_loan_ec')
				_gHlp.removeLoading('proceed_approval')
				this.$router.push('/customers-list/all-customer');
			}).catch(err => {
				_gHlp.removeLoading('fetch_loan_ec')
				_gHlp.removeLoading('proceed_approval')
			});
		}
	}
}

</script>
